const data = {
  schemaVersion: 'market.v2',
  Headline: 'Packaged food: steady global growth with regional divergence',
  Market: 'Global packaged food',
  Introduction:
    'The Kraft Heinz Company is a global leader in the food and beverage industry, recognized for its iconic brands and commitment to quality, sustainability, and innovation. As the third-largest in North America and fifth globally, it serves diverse consumers and businesses with high-quality food solutions.',
  'Market Size and Growth':
    'The global packaged food market continues to expand, driven by demand for convenient, high-quality, and nutritious options across developed and emerging economies. Core categories include ready meals, sauces and condiments, snacks, and more.',
  CurrentMarketSize: 3730000000000,
  CAGR: 5.2,
  RegionalDistribution: {
    'North America': { Share: 28, MarketSize: 1044400000000 },
    Europe: { Share: 23, MarketSize: 857900000000 },
    'East Asia': { Share: 19, MarketSize: 708700000000 },
    'Southeast Asia': { Share: 12, MarketSize: 447600000000 },
    Oceania: { Share: 2, MarketSize: 74600000000 },
    LatAm: { Share: 8, MarketSize: 298400000000 },
    'Middle East': { Share: 3, MarketSize: 111900000000 },
    Africa: { Share: 5, MarketSize: 186500000000 }
  },
  RegionalGrowth: {
    'North America': {
      CAGR_2019_2024: 4.2,
      CAGR_2024_2030_Base: 4.6,
      CAGR_2024_2030_Downside: 3.0,
      Drivers: 'Stable demand for branded packaged foods; premiumization; transparency and sustainability innovation.',
      Risks: 'Private label competition; shift to fresh/local; supply-chain disruptions.'
    },
    Europe: {
      CAGR_2019_2024: 3.1,
      CAGR_2024_2030_Base: 3.6,
      CAGR_2024_2030_Downside: 2.2,
      Drivers: 'Convenience demand; health and wellness; packaging and flavor innovation.',
      Risks: 'Economic slowdowns; regulatory hurdles; preference for fresh/unprocessed.'
    },
    'East Asia': {
      CAGR_2019_2024: 6.5,
      CAGR_2024_2030_Base: 6.8,
      CAGR_2024_2030_Downside: 4.6,
      Drivers: 'Urbanization; rising middle class; retail and convenience innovation.',
      Risks: 'Regulatory change; food safety concerns; competitive intensity.'
    },
    'Southeast Asia': {
      CAGR_2019_2024: 7.8,
      CAGR_2024_2030_Base: 7.9,
      CAGR_2024_2030_Downside: 5.4,
      Drivers: 'Rapid urbanization; income growth; young demographics; modern retail expansion.',
      Risks: 'Infrastructure gaps; policy risk; local competition.'
    },
    Oceania: {
      CAGR_2019_2024: 2.6,
      CAGR_2024_2030_Base: 2.9,
      CAGR_2024_2030_Downside: 1.7,
      Drivers: 'High quality standards; convenience preference; solid retail environment.',
      Risks: 'Small population; high competition; price sensitivity.'
    },
    LatAm: {
      CAGR_2019_2024: 5.8,
      CAGR_2024_2030_Base: 6.1,
      CAGR_2024_2030_Downside: 3.9,
      Drivers: 'Urbanization; retail expansion; income growth.',
      Risks: 'Economic volatility; currency fluctuations; trade frictions.'
    },
    'Middle East': {
      CAGR_2019_2024: 4.9,
      CAGR_2024_2030_Base: 5.2,
      CAGR_2024_2030_Downside: 3.4,
      Drivers: 'High disposable incomes; premium/imported demand; tourism.',
      Risks: 'Geopolitical risk; import dependency; regulatory shifts.'
    },
    Africa: {
      CAGR_2019_2024: 6.0,
      CAGR_2024_2030_Base: 6.3,
      CAGR_2024_2030_Downside: 4.1,
      Drivers: 'Population growth; urbanization; retail and cold-chain buildout.',
      Risks: 'Political instability; logistics constraints; affordability.'
    }
  },
  'Defining Features':
    'Broad portfolio of household brands, resilient global supply chain, and consistent quality and sustainability commitments supporting scale across retail and foodservice.',
  DriversList: [
    {
      title: 'Urbanization and On-the-Go Consumption',
      text: 'More than half the world’s population lives in urban areas; urban share was ~57% in recent estimates and is projected to keep rising, supporting convenience-led packaged categories that outgrow overall food retail in high-density metros.'
    },
    {
      title: 'Middle-Class Expansion and Premiumization',
      text: 'The global middle class continues to expand by hundreds of millions by 2030 in mainstream forecasts, increasing per-capita packaged-food spend in many emerging markets and accelerating premium segment growth versus mass.'
    },
    {
      title: 'Packaging Technology and Shelf-Life Innovation',
      text: 'Adoption of MAP, aseptic processing and HPP extends shelf life (often multiple-fold depending on category), enabling broader distribution, lower spoilage and faster roll-out of convenience SKUs. Regulatory and recycled-content targets (e.g., EU) further push packaging innovation.'
    },
    {
      title: 'E-Commerce and Omnichannel Grocery Growth',
      text: 'E-grocery penetration has risen sharply: online grocery share in many NA/EU markets is in the low-double digits (~10–15%) and substantially higher in China (>20–25%); global online packaged-food sales have grown at double-digit rates since 2020.'
    }
  ],
  ChallengesList: [
    {
      title: 'Health Trends and Regulatory Pressures',
      text: 'Front-of-pack labeling, SSB/sugar taxes and HFSS restrictions have proliferated across many jurisdictions, driving reformulation, lab testing and compliance costs for affected SKUs.'
    },
    {
      title: 'Private Label Growth and Price Sensitivity',
      text: 'Private-label/store brands continued to grow in 2023–24 (large shares in Europe and a rising share in North America), and promotional/deal rates remain high in mature markets — pressuring mix and net price realisation.'
    },
    {
      title: 'Commodity Volatility and Supply Chain Disruptions',
      text: 'Commodity and input prices (oils, grains, proteins) and freight have shown meaningful intra-year swings; container freight and FAO commodity indices remain volatile versus pre-pandemic baselines, increasing procurement and lead-time risk.'
    },
    {
      title: 'Sustainability Mandates and Packaging Costs',
      text: 'EPR schemes, recycled-content targets and proposed mandatory PCR levels (e.g., ~30%+ by 2030 in EU discussions) are raising packaging cost and compliance burdens; Scope-3 reduction targets force multi-year supplier decarbonisation and capex programs.'
    }
  ],
  Footnotes: {
    line1:
      '1) Base case assumes steady macro environment; 2) Downside assumes persistent macro challenges; Market scope includes ready meals, sauces, condiments, snacks, and convenience foods.',
    line2: 'Regional market sizes use current FX; projections consider urbanization, income growth, and evolving consumer preferences.',
    source: 'Askpot AI Analysis Report 2025'
  }
};

export default data;
